import { Icon } from '@fluentui/react';
import React from 'react';
import ReactApexChart from "react-apexcharts";
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { formatNumber, isNullUndefined } from '../../../../../../common/Helpers';

function ChartGaugeOPF(props) {
const { t, i18n } = useTranslation();

const { 
	inputParam_ComponentContent = null,
	selectedGaugeDataPointIndex = null,
	inputParam_Title = null
} = props;


const indexStart = inputParam_ComponentContent !== null ? ((selectedGaugeDataPointIndex !== null && selectedGaugeDataPointIndex !== undefined) ? selectedGaugeDataPointIndex : (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals.length -1 : inputParam_ComponentContent.l_dataserie[0].l_vals.length -1)) : undefined
const indexEnd = inputParam_ComponentContent !== null ? ((selectedGaugeDataPointIndex !== null && selectedGaugeDataPointIndex !== undefined) ? (selectedGaugeDataPointIndex  -1): (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals.length -2 : inputParam_ComponentContent.l_dataserie[0].l_vals.length -2)) : undefined

const variationstr = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? t('data-lang-lbl-nopreviousdata') : (
	inputParam_ComponentContent.l_dataserie === undefined ? 
	(formatNumber(inputParam_ComponentContent.l_vals[indexStart].scopeValue - inputParam_ComponentContent.l_vals[indexEnd].scopeValue) + "%") :
	(inputParam_ComponentContent.l_dataserie[0].l_vals.length > 0 ? (formatNumber(inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].scopeValue - inputParam_ComponentContent.l_dataserie[0].l_vals[indexEnd].scopeValue) + "%") : '--')
)) : t('data-lang-lbl-nopreviousdata')

const variation = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? 0 : (
	inputParam_ComponentContent.l_dataserie === undefined ? 
	(inputParam_ComponentContent.l_vals[indexStart].scopeValue - inputParam_ComponentContent.l_vals[indexEnd].scopeValue) :
	(inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].scopeValue - inputParam_ComponentContent.l_dataserie[0].l_vals[indexEnd].scopeValue)
)) : 0

const previousValue = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? 0 : (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals[indexStart].scopeValue :  inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].scopeValue)) : 0
const serieTime = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? '' : (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals[indexStart].periodId.toString() : inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].periodId.toString())) : ''
const color = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? 'gray' : (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals[indexStart].color : inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].color)) : 'gray'

const valorOriginal = previousValue;
const valorMaximo = inputParam_ComponentContent !== null ? (inputParam_ComponentContent.l_vals.length > 0 ? inputParam_ComponentContent.l_vals.reduce((max, objeto) => objeto.scopeValue > max ? objeto.scopeValue : max, inputParam_ComponentContent.l_vals[0].scopeValue) : null) : null;
const valorEscalar = (valorOriginal === 0 && valorMaximo === 0) ? 0 : valorMaximo !== null ? (valorOriginal / valorMaximo) * 100 : 0;

const options = {
	title: {
		text: inputParam_Title ? inputParam_Title : 'OPF',
		align: 'center',
	},
	subtitle: {
		text: serieTime,
		align: 'center',
	},
	chart: {
		type: 'radialBar',
		offsetY: -20,
		sparkline: {
			enabled: true
		},
		height: 300
	},
	plotOptions: {
		radialBar: {
			startAngle: -90,
			endAngle: 90,
			track: {
				background: "#e7e7e7",
				strokeWidth: '97%',
				margin: 5,
				dropShadow: {
					enabled: true,
					top: 2,
					left: 0,
					color: '#999',
					opacity: 1,
					blur: 2
				}
			},
			dataLabels: {
				name: {
					show: false
				},
				value: {
					offsetY: -2,
					fontSize: '22px',
					show : false,
				}
			}
		}
	},
	colors: ['#1F7BE8'],
	grid: {
		padding: {
			top: -10
		}
	},
	fill: {
		type: 'solid',
		colors: ['#1F7BE8'],
	},
}

return (<>
		{
			inputParam_ComponentContent &&
			<Col xl={4} className='my-auto p-0 m-0'>
				<Row>
					<Col>
						<ReactApexChart
							options={options}
							series={[valorEscalar !== null && valorEscalar !== undefined ? valorEscalar : 0]}
							type="radialBar"
							height={300} />
					</Col>
				</Row>
				<Row style={{ marginTop: "-40px" }}>
					<Col>
						<Row>
							<Col className='col-auto mx-auto'>
								<h6>{`${t('data-lang-lbl-total')} ${ !isNullUndefined(valorOriginal) ? formatNumber(valorOriginal) : '--' }`}</h6>
							</Col>
						</Row>
						<Row>
							<Col className='d-flex col-auto mx-auto'>
									<h6><b>{`${t('data-lang-lbl-variation')}`}</b>:</h6>
									&nbsp;&nbsp;
									{
										variationstr !== t('data-lang-lbl-nopreviousdata') &&
										<>
											<Icon
												iconName={ variation > 0 ? 'FlickDown' : (variation < 0 ? 'FlickUp' : 'ToggleFilled') }
												className='my-auto'
												style={
													variation > 0 ? 
														{color: "#25aa34", position: "relative", bottom: "7px"} :
														(
															variation < 0 ?
																{color: "#d93b3b", position: "relative", top: "2px"} :
																{color: "#999999", position: "relative", bottom: "2px"}
														)
												}
											/>&nbsp;
										</>
									}
									
									<h6><b>{`${ variationstr }`}</b></h6>
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
		}
		</>);
};

export default ChartGaugeOPF;